module.exports = __webpack_public_path__ + "img/Frame 214.ae116784.svg";